
export const CUSTOM_TABLE_STYLES = {
    rows: {
        style: {
            '&:hover': {
                backgroundColor: 'rgb(155,202,255)',
            },
        },
    },
};